import React from "react";
import {
  FaExchangeAlt,
  FaFileContract,
  FaWater,
  FaProjectDiagram,
  FaLandmark,
} from "react-icons/fa";

function CustomDEDev() {
  const reasons = [
    {
      title: "Custom DEX Development",
      desc: "Tailored platforms supporting various assets and trading pairs.",
      icon: <FaExchangeAlt size={35} />,
    },
    {
      title: "Smart Contract Integration",
      desc: "Automated and secure transaction processing.",
      icon: <FaFileContract size={35} />,
    },
    {
      title: "Liquidity Pool Setup",
      desc: "Enabling decentralized liquidity for efficient trading.",
      icon: <FaWater size={35} />,
    },
    {
      title: "Cross-Chain Compatibility",
      desc: "Allowing seamless asset trading across different blockchain networks.",
      icon: <FaProjectDiagram size={35} />,
    },
    {
      title: "Governance & Staking Mechanisms",
      desc: "Adding features like decentralized governance and staking to enhance user engagement.",
      icon: <FaLandmark size={35} />,
    },
  ];
  return (
    <>
      <div
        className="services-area pt-120 pb-120 mt-5"
        style={{ background: "#ffffff" }}
      >
        <div className="container text-center">
          <h2
            className="title fw-extrabold mb-4"
          // style={{ fontSize: "40px", letterSpacing: "-1px" }}
          >
            Decentralized Exchange Development by Xeer Technology
          </h2>

          <p
            className="mt-2 mb-5 mx-auto text-muted fs-5"
            style={{ maxWidth: "800px" }}
          >
            As decentralized development vanguards, our technically astute
            developers consistently synthesize complex enterprise requirements.
          </p>

          <div className="row g-4 justify-content-center">
            {reasons.map((reason, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="reason-card border-0 p-5 text-center h-100"
                  style={{
                    borderRadius: "32px",
                    background: "#f9faff",
                    border: "1px solid #f0f3ff",
                    transition: "all 0.4s ease",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.boxShadow =
                      "0 25px 50px rgba(0, 0, 0, 0.04)";
                    e.currentTarget.style.borderColor = "#3366ff20";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "#f9faff";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#f0f3ff";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "70px",
                      height: "70px",
                      fontSize: "28px", // untouched
                      backgroundColor: "#ffffff",

                      borderRadius: "20px",
                      boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                    }}
                  >
                    {reason.icon}
                  </div>

                  <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                    {reason.title}
                  </h5>

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#6c757d",
                      lineHeight: "1.7",
                      marginBottom: 0,
                    }}
                  >
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomDEDev;
